<div class="container">
    <div class="card">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Crear nuevo examen</mat-card-title>
            </mat-card-header>
            <mat-card-content>

                <form [formGroup]="exam" (ngSubmit)="sendExam()">
                    <div class="form1">


                        <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                            [floatLabel]="floatLabelControl.value">
                            <mat-label>Nombre del examen</mat-label>
                            <input matInput formControlName="name" required>
                        </mat-form-field>
                        <mat-error *ngIf="exam.get('name').errors && exam.get('name').touched" [color]="black">Por favor
                            introduzca un nombre válido</mat-error>


                        <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                            [floatLabel]="floatLabelControl.value">
                            <mat-label>Ponderación</mat-label>
                            <input matInput formControlName="weighing" required>
                        </mat-form-field>
                        <mat-error *ngIf="exam.get('weighing').errors && exam.get('weighing').touched">Por favor
                            introduzca un valor válido</mat-error>


                        <mat-form-field appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                            [floatLabel]="floatLabelControl.value">
                            <mat-label>Descripción</mat-label>
                            <input matInput formControlName="description" required>
                        </mat-form-field>
                        <mat-error *ngIf="exam.get('description').errors && exam.get('description').touched">Por favor
                            introduzca una descripción válida</mat-error>

                    </div>

                </form>
                <div (click)="sendExam()" class="sendbutton mat-elevation-z4" matRipple [matRippleRadius]="300"
                    [matRippleColor]="'rgb(255, 87, 118, 0.3)'">
                    <span class="buttontext">Guardar Examen</span>

                </div>
            </mat-card-content>
        </mat-card>

    </div>


    <div class="card">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Crear Pregunta</mat-card-title>
            </mat-card-header>
            <mat-card-content>

                <form [formGroup]="question" (ngSubmit)="sendQuestion()">
                    <div class="form1">

                        <mat-form-field appearance="fill">
                            <mat-label>Seleccionar examen</mat-label>
                            <mat-select formControlName="exam_id">
                                <mat-option *ngFor="let examname of exams" value="{{examname.id}}">{{examname.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Tipo de pregunta</mat-label>
                            <mat-select formControlName="question_type">
                                <mat-option value="1">Opción Múltiple</mat-option>
                               <!--  <mat-option value="2">Selección Múltiple</mat-option>
                                <mat-option value="5">Ordenar Respuestas</mat-option>
                                <mat-option value="4">Relacionar columnas</mat-option> -->
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Pregunta</mat-label>
                            <input matInput formControlName="question" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill" formGroupName="answer1">
                            <mat-label>Respuesta correcta</mat-label>
                            <input matInput formControlName="answer" required>
                        </mat-form-field>

                        <mat-form-field appearance="fill" formGroupName="answer2">
                            <mat-label>Respuesta</mat-label>
                            <input matInput formControlName="answer" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill" formGroupName="answer3">
                            <mat-label>Respuesta</mat-label>
                            <input matInput formControlName="answer" required>
                        </mat-form-field>


                    </div>
                </form>
                <div (click)="sendQuestion()" class="sendbutton mat-elevation-z4" matRipple [matRippleRadius]="300"
                    [matRippleColor]="'rgb(255, 87, 118, 0.3)'">
                    <span class="buttontext">Guardar Pregunta</span>
                </div>
            </mat-card-content>
        </mat-card>

    </div>

</div>